import { searchConfig, dictionaryConfig } from "./typesense-server-config";
import { SearchClient as TypesenseSearchClient } from "typesense";

let INDEX_NAME;
let sortBy;

export async function getIndexSize(serverType = "default") {
  // Select the appropriate server configuration based on the serverType
  let TYPESENSE_SERVER_CONFIG;
  if (serverType === "dictionary") {
    TYPESENSE_SERVER_CONFIG = dictionaryConfig;
    INDEX_NAME = import.meta.env.VITE_DICTIONARY_TYPESENSE_COLLECTION_NAME;
    sortBy = "created_at:asc";
  } else {
    TYPESENSE_SERVER_CONFIG = searchConfig;
    INDEX_NAME = import.meta.env.VITE_TYPESENSE_COLLECTION_NAME;
    sortBy = "date:desc";
  }

  // Initialize Typesense client with the selected server config
  const typesenseSearchClient = new TypesenseSearchClient(
    TYPESENSE_SERVER_CONFIG
  );

  // Perform the search to get index size
  const results = await typesenseSearchClient
    .collections(INDEX_NAME)
    .documents()
    .search({ q: "*", sort_by: sortBy });

  return results["found"];
}
